import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../hooks/useAppStore';
import { setConsent, selectConsentStatus } from '../../store/slices/consentSlice';

export function CookieConsent() {
  const dispatch = useAppDispatch();
  const status = useAppSelector(selectConsentStatus);

  if (status !== 'unknown') return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] bg-[#1a1218]/95 backdrop-blur-xl border-t border-white/10 px-4 py-4 sm:px-6">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1 min-w-0">
          <p className="text-offwhite/80 text-sm leading-relaxed">
            We use cookies to improve your experience and show relevant ads.
            By clicking <strong className="text-offwhite">Accept</strong>, you consent to our use of cookies as described in our{' '}
            <Link to="/cookies" className="text-magenta hover:text-magenta/80 underline underline-offset-2 transition-colors">
              Cookie Policy
            </Link>
            {' '}and{' '}
            <Link to="/privacy-policy" className="text-magenta hover:text-magenta/80 underline underline-offset-2 transition-colors">
              Privacy Policy
            </Link>.
          </p>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={() => dispatch(setConsent('declined'))}
            className="text-offwhite/40 hover:text-offwhite text-sm font-medium transition-colors px-4 py-2 rounded-xl hover:bg-white/5"
          >
            Decline
          </button>
          <button
            onClick={() => dispatch(setConsent('accepted'))}
            className="bg-magenta text-white text-sm font-bold px-5 py-2 rounded-xl hover:bg-magenta/90 transition-colors shadow-lg shadow-magenta/20"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}
